<script>
  import getUrlParams from '../modules/getUrlParams/index.js'

  const params = getUrlParams()

  $: title = params.title || '送信 受け付け 完了'
  $: message = params.message || '今日もお仕事お疲れ様でした！'
</script>

<section class="box">
  <h1>{title}</h1>
  <p>
    <span>{message}</span>
  </p>
  <p>
    <a href="/">＞＞ 前の画面に戻る ＜＜</a>
  </p>
</section>
